import { Writer, Editor } from '@ckeditor/ckeditor5-core/src/editor';

export const addEmptyParagraphAfterPlugin = (
  editor: Editor,
  writer: Writer,
  element: Element,
): void => {
  // Move the document selection to the element.
  writer.setSelection(element, 'after');

  // Create an empty paragraph and add that after the block
  const paragraph = writer.createElement('paragraph');

  editor.model.insertContent(paragraph);

  // move selection back to element
  writer.setSelection(element, 'in');
};
